import { H2 } from '@/components'
import { Loader } from '@ur-solutions/react-components'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { SectionHeader } from '../common'

export const ExportSectionHeader = styled.h2`
  margin-bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const MassExportSectionHeader = styled(SectionHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

interface ExportSectionProps extends PropsWithChildren {
  className?: string

  header: string
  loading?: boolean
}

export function ExportSection({
  children,
  className,

  header,
  loading = false,
}: ExportSectionProps) {
  return (
    <div className={className}>
      <header className="flex items-center gap-2 p-0">
        <H2>{header}</H2>
        {loading && <Loader.Spinner size={22} thickness={4} />}
      </header>

      <div className="space-y-4">{children}</div>
    </div>
  )
}
